define('util/wse',["require", "exports", "./airspeed", "./physics", "./polar-library"], function (require, exports, airspeed_1, physics_1, polar_library_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.cubicBezier = exports.trd = exports.td = exports.simdata2csv = exports.simdata2flysight = exports.rollEngineColor = exports.speedpagePolarColor = exports.SimulatorPolarColor = exports.studioPolarColor = exports.polarColor = exports.aoaPolarColor = exports.colorByAoa = exports.AoaModel = exports.sstocoeff = exports.coefftoss = exports.changetablesize = exports.polartoss = exports.samplePolar = exports.samplePolarColors = exports.samplePolartable = exports.samplePolarC = exports.getslickaoafromss = exports.getssfromwsaoa = exports.getwsaoafromss = exports.samplespeedtoflytable = exports.samplespeedtofly = exports.samplemaxg = exports.getvys = exports.getgrindex = exports.getsustainedindex = exports.getsustained = exports.getspeedtofly = exports.getmaxg = exports.getminspeed = exports.getmaxspeed = exports.getspeeddirty = exports.getspeedsbetween = exports.getspeedbetween = exports.getspeed = exports.getcoefficients = exports.getS = exports.getStandardAtmosphere = exports.getrho = exports.generatew3d = exports.generate3d = exports.generate = void 0;
    /**
     * Generate synthetic 3d flight data using wingsuit equations
     * Uses Runge_Cutta method for Integration: Acceleration to
     * Velocity to Position.
     *
     * @param time the number of seconds to generate
     * @param vxs sustained_x speed of your suit and configuration (m/s)
     * @param vys sustained_y speed of your suit and configuration (m/s)
     */
    function generate(time, init_vxs, init_vys) {
        var dt = 0.1;
        var data = [];
        // Initial conditions
        var previous = {
            millis: 0,
            x: 0,
            y: 0,
            north: 0,
            east: 0,
            vx: 5,
            vy: 0,
            vxs: init_vxs,
            vys: init_vys,
            heading: 0,
            roll: 0
        };
        // store t=0
        data.push(previous);
        // Initial acceleration is ignored and recalculated using wse
        // initialize loop variables
        var vx = previous.vx;
        var vy = -previous.vy;
        var x = previous.x;
        var y = -previous.y;
        var north = previous.north;
        var east = previous.east;
        var heading = previous.heading;
        var vnorth = vx * Math.cos(heading);
        var veast = vx * Math.sin(heading);
        var pvnorth = vx * Math.cos(heading);
        var pveast = vx * Math.sin(heading);
        var v = Math.pow(vnorth * vnorth + veast * veast + vy * vy, .5);
        var roll = 0;
        // initial KL KD from sustained speeds
        var vxs = previous.vxs;
        var vys = previous.vys;
        var total2 = vxs * vxs + vys * vys;
        var totalFactor = Math.pow(total2, 1.5);
        var kl = vxs / totalFactor;
        var kd = vys / totalFactor;
        // Calculate initial acceleration
        var ax = v * (kl * vy * Math.cos(roll) - kd * vx);
        var ay = 1 - v * (kl * vx * Math.cos(roll) + kd * vy);
        var az = -kl * v * v * Math.sin(roll);
        var ae = Math.sin(heading + Math.PI / 2) * az + Math.sin(heading) * ax;
        var an = Math.cos(heading) * ax + Math.cos(heading + Math.PI / 2) * az;
        // Integrate
        for (var t = 0; t < time; t += dt) {
            // velocity is based on previous velocity and acceleration
            vnorth = vnorth + an * physics_1.gravity * dt;
            veast = veast + ae * physics_1.gravity * dt;
            vx = Math.pow(vnorth * vnorth + veast * veast, .5);
            vy = vy + ay * physics_1.gravity * dt;
            v = Math.pow(vnorth * vnorth + veast * veast + vy * vy, .5);
            // position is based on previous pos and vel and current vel
            north = north + (pvnorth + vnorth) / 2 * dt;
            east = east + (pveast + veast) / 2 * dt;
            x = Math.pow(north * north + east * east, .5);
            y = y + (-previous.vy + vy) / 2 * dt;
            // heading
            heading = Math.atan2(vnorth, veast);
            // calculate new sustained speeds based on new altitude
            vxs = (0, airspeed_1.adjustSpeed)(previous.vxs, 1000 + previous.y, 1000 - y);
            vys = (0, airspeed_1.adjustSpeed)(previous.vys, 1000 + previous.y, 1000 - y);
            // acceleration is based on current velocity and current sustained speeds
            ax = v * (kl * vy * Math.cos(roll) - kd * vx);
            ay = 1 - v * (kl * vx * Math.cos(roll) + kd * vy);
            az = -kl * v * v * Math.sin(roll);
            ae = Math.sin(heading + Math.PI / 2) * az + Math.sin(heading) * ax;
            an = Math.cos(heading) * ax + Math.cos(heading + Math.PI / 2) * az;
            // update kl kd for next accel update prevvn,ve
            total2 = vxs * vxs + vys * vys;
            totalFactor = Math.pow(total2, 1.5);
            kl = vxs / totalFactor;
            kd = vys / totalFactor;
            pvnorth = vnorth;
            pveast = veast;
            // write data
            var next = {
                millis: previous.millis + dt * 1000,
                x: x,
                y: -y,
                north: north,
                east: east,
                vx: vx,
                vy: -vy,
                vxs: vxs,
                vys: vys,
                heading: heading,
                roll: roll
            };
            data.push(next);
            previous = next;
        }
        return data;
    }
    exports.generate = generate;
    /**
     * Generate synthetic 3d flight data using wingsuit equations
     * Uses Runge_Cutta method for Integration: Acceleration to
     * Velocity to Position.
     *
     * @param time the number of seconds to generate
     * @param vxs sustained_x speed of your suit and configuration (m/s)
     * @param vys sustained_y speed of your suit and configuration (m/s)
     */
    function generate3d(time, initialconditions) {
        var dt = time; //dt and time...
        var data = [];
        // Initial conditions
        var previous = initialconditions;
        // store t=0
        data.push(previous);
        // Initial acceleration is calculated using wse
        // initialize loop variables
        var millis = previous.millis;
        var vx = previous.vx;
        var vy = previous.vy;
        var x = previous.x;
        var y = previous.y;
        var north = previous.north;
        var east = previous.east;
        var heading = previous.heading;
        var vnorth = vx * Math.cos(heading);
        var veast = vx * Math.sin(heading);
        var pvnorth = vx * Math.cos(heading);
        var pveast = vx * Math.sin(heading);
        var v = Math.pow(vnorth * vnorth + veast * veast + vy * vy, .5);
        var roll = previous.roll;
        // initial KL KD from sustained speeds
        var vxs = previous.vxs;
        var vys = previous.vys;
        var total2 = vxs * vxs + vys * vys;
        var totalFactor = Math.pow(total2, 1.5);
        var kl = vxs / totalFactor;
        var kd = vys / totalFactor;
        // Calculate initial acceleration
        var ax = v * (kl * vy * Math.cos(roll) - kd * vx);
        var ay = 1 - v * (kl * vx * Math.cos(roll) + kd * vy);
        var az = -kl * v * v * Math.sin(roll);
        var ae = Math.sin(heading + Math.PI / 2) * az + Math.sin(heading) * ax;
        var an = Math.cos(heading) * ax + Math.cos(heading + Math.PI / 2) * az;
        // Integrate
        for (var t = 0; t < time; t += dt) {
            millis = millis + dt * 1000;
            // velocity is based on previous velocity and acceleration
            vnorth = vnorth + an * physics_1.gravity * dt;
            veast = veast + ae * physics_1.gravity * dt;
            // console.log(vnorth,pvnorth,veast,pveast,Math.atan2(veast,vnorth)*180/Math.PI,Math.atan2(pveast,pvnorth)*180/Math.PI)
            vx = Math.pow(vnorth * vnorth + veast * veast, .5);
            vy = vy + ay * physics_1.gravity * dt;
            v = Math.pow(vnorth * vnorth + veast * veast + vy * vy, .5);
            // position is based on previous pos and vel and current vel
            north = north + (pvnorth + vnorth) / 2 * dt;
            east = east + (pveast + veast) / 2 * dt;
            x = Math.pow(north * north + east * east, .5);
            y = y + (previous.vy + vy) / 2 * dt;
            // heading
            heading = Math.atan2(veast, vnorth);
            // console.log(vnorth,veast,heading*180/Math.PI)
            // acceleration is based on current velocity and current sustained speeds
            ax = v * (kl * vy * Math.cos(roll) - kd * vx);
            ay = 1 - v * (kl * vx * Math.cos(roll) + kd * vy);
            az = -kl * v * v * Math.sin(roll);
            ae = Math.sin(heading + Math.PI / 2) * az + Math.sin(heading) * ax;
            an = Math.cos(heading) * ax + Math.cos(heading + Math.PI / 2) * az;
            // update prevvn,ve
            pvnorth = vnorth;
            pveast = veast;
            // console.log(ax,az,ae,an,veast,vnorth,heading*180/Math.PI,roll*180/Math.PI)
            // write data
            var next = {
                millis: millis,
                x: x,
                y: y,
                north: north,
                east: east,
                vx: vx,
                vy: vy,
                vxs: vxs,
                vys: vys,
                heading: heading,
                roll: roll
            };
            data.push(next);
            previous = next;
        }
        return data;
    }
    exports.generate3d = generate3d;
    function generatew3d(time, initialconditions, wind, inverted) {
        var dt = time; //dt and time...
        // Initial conditions
        var previous = initialconditions;
        // Initial acceleration is calculated using wse
        // initialize loop variables
        var dtor = Math.PI / 180;
        var wvn = wind.speed * Math.cos(wind.direction * dtor) * Math.cos(wind.inclination * dtor);
        var wve = wind.speed * Math.sin(wind.direction * dtor) * Math.cos(wind.inclination * dtor);
        var wvd = wind.speed * Math.sin(-wind.inclination * dtor);
        var millis = previous.millis;
        var vx = previous.vx;
        var vy = previous.vy;
        var x = previous.x;
        var y = previous.y;
        var north = previous.north;
        var east = previous.east;
        var heading = previous.heading;
        var vnorth = vx * Math.cos(heading);
        var veast = vx * Math.sin(heading);
        var avnorth = wvn + vx * Math.cos(heading);
        var aveast = wve + vx * Math.sin(heading);
        var avx = Math.pow(avnorth * avnorth + aveast * aveast, .5);
        var avy = wvd + vy;
        var headingas = Math.atan2(aveast, avnorth);
        var pvnorth = vx * Math.cos(heading);
        var pveast = vx * Math.sin(heading);
        var v = Math.pow(vnorth * vnorth + veast * veast + vy * vy, .5);
        var vas = Math.pow(avnorth * avnorth + aveast * aveast + avy * avy, .5);
        var roll = previous.roll;
        // fix for when wingsuit is inverted
        var croll = inverted ? roll + Math.PI : roll;
        // initial KL KD from sustained speeds
        var vxs = previous.vxs;
        var vys = previous.vys;
        var total2 = vxs * vxs + vys * vys;
        var totalFactor = Math.pow(total2, 1.5);
        var kl = vxs / totalFactor;
        var kd = vys / totalFactor;
        // Calculate initial acceleration
        var ax = vas * (kl * avy * Math.cos(croll) - kd * avx);
        var ay = 1 - vas * (kl * avx * Math.cos(croll) + kd * avy);
        var az = -kl * vas * vas * Math.sin(croll);
        var ae = Math.sin(headingas + Math.PI / 2) * az + Math.sin(headingas) * ax;
        var an = Math.cos(headingas) * ax + Math.cos(headingas + Math.PI / 2) * az;
        // Integrate
        millis = millis + dt * 1000;
        // velocity is based on previous velocity and acceleration
        vnorth = vnorth + an * physics_1.gravity * dt;
        veast = veast + ae * physics_1.gravity * dt;
        // console.log(vnorth,pvnorth,veast,pveast,Math.atan2(veast,vnorth)*180/Math.PI,Math.atan2(pveast,pvnorth)*180/Math.PI)
        vx = Math.pow(vnorth * vnorth + veast * veast, .5);
        vy = vy + ay * physics_1.gravity * dt;
        //v = Math.pow(vnorth * vnorth + veast * veast + vy * vy, .5)
        // position is based on previous pos and vel and current vel
        north = north + (pvnorth + vnorth) / 2 * dt;
        east = east + (pveast + veast) / 2 * dt;
        x = Math.pow(north * north + east * east, .5);
        y = y + (previous.vy + vy) / 2 * dt;
        // heading
        heading = Math.atan2(veast, vnorth);
        var data = {
            millis: millis,
            x: x,
            y: y,
            north: north,
            east: east,
            vx: vx,
            vy: vy,
            vxs: vxs,
            vys: vys,
            heading: heading,
            roll: roll
        };
        return data;
    }
    exports.generatew3d = generatew3d;
    /*
    export function translate3d(t:Translation,r:Rotation,dt: number, initialconditions: WSPoint): WSPoint {
      const p =t.getPosition()
      const north = p.x
      const east = p.y
      const down = p.z
      const x = Math.pow(north * north + east * east, .5)
      const y = down
      const vi = t.getVelocityInertial()
      const vx = Math.pow( vi.vn*vi.vn+vi.ve*vi.ve, .5)
      const vy = vi.vd
      const heading = Math.atan2(vi.ve, vi.vn)
      const roll = r.getEulerAngles().phi
      const vxs = initialconditions.vxs
      const vys = initialconditions.vys
      const data: WSPoint = {
        millis: initialconditions.millis+dt*1000,
        x,
        y,
        north,
        east,
        vx,
        vy,
        vxs,
        vys,
        heading,
        roll
      }
    
      return data
    }
    
    // fitpolar gets the coefficients from clean trimmed data
    export function fitpolar(trimmeddata: Point[]): WSEQPolar {
      const coeffs = getSlopeInt(trimmeddata, (d) => d.cl * d.cl, (d) => d.cd)
      const maxobclarr = trimmeddata.map((o) => o.cl)
      const maxobcl = Math.max(...maxobclarr)
      const minobclarr = trimmeddata.map((o) => o.cl)
      const minobcl = Math.min(...minobclarr)
      return {
        name: "newpolar",
        type: "ws",
        public: true,
        polarslope: coeffs[0],
        polarclo: 0,
        polarmindrag: coeffs[1],
        rangemincl: minobcl,
        rangemaxcl: maxobcl,
        s: 2,
        m: 75
      }
    }// fitpolar gets the coefficients from clean trimmed data
    export function fitpolarc(trimmeddata: Coefficients[], s: number, m: number): WSEQPolar {
      const coeffs = getSlopeInt(trimmeddata, (d) => d.cl * d.cl, (d) => d.cd)
      const maxobclarr = trimmeddata.map((o) => o.cl)
      const maxobcl = Math.max(...maxobclarr)
      const minobclarr = trimmeddata.map((o) => o.cl)
      const minobcl = Math.min(...minobclarr)
      return {
        name: "newpolar",
        type: "ws",
        public: true,
        polarslope: coeffs[0],
        polarclo: 0,
        polarmindrag: coeffs[1],
        rangemincl: minobcl,
        rangemaxcl: maxobcl,
        s: s,
        m: m
      }
    }
    // fitpolar gets the coefficients from clean trimmed data
    export function fitpolarc2(trimmeddata: Coefficients[], s: number, m: number): WSEQPolar {
      //const speeds = trimmeddata.map((c) => coefftoss(c.cl, c.cd, s, m, 1))
      const coeffs = leastSquaresQuadratic(trimmeddata, (d) => d.cl, (d) => d.cd)
      const maxobclarr = trimmeddata.map((o) => o.cl)
      const maxobcl = Math.max(...maxobclarr)
      const minobclarr = trimmeddata.map((o) => o.cl)
      const minobcl = Math.min(...minobclarr)
      const clo = -coeffs[1] / (2 * coeffs[0])
      const mindrag = coeffs[2] - coeffs[1] * coeffs[1] / (4 * coeffs[0])
      return {
        name: "newpolar",
        type: "ws",
        public: true,
        polarslope: coeffs[0],
        polarclo: clo,
        polarmindrag: mindrag,
        rangemincl: minobcl,
        rangemaxcl: maxobcl,
        s: s,
        m: m
      }
    }
    //get higher order fit not working
    export function fitpolarc6(trimmeddata: Coefficients[], s: number, m: number): WSEQPolar {
      const sses: number[] = []
      const speeds = trimmeddata.map((c) => coefftoss(c.cl, c.cd, s, m, 1))
      const quads = leastSquaresQuadratic(speeds, (d) => d.vxs, (d) => d.vys)
      const fours = getSlopeInt(speeds, (d) => d.vxs * d.vxs * d.vxs * d.vxs, (d) => d.vys)
      const sixes = getSlopeInt(speeds, (d) => d.vxs * d.vxs * d.vxs * d.vxs * d.vxs * d.vxs, (d) => d.vys)
    
      console.log(quads, fours, sixes)
      const coeffs = [quads[0], quads[2]]
      const maxobclarr = trimmeddata.map((o) => o.cl)
      const maxobcl = Math.max(...maxobclarr)
      const minobclarr = trimmeddata.map((o) => o.cl)
      const minobcl = Math.min(...minobclarr)
      return {
        name: "newpolar",
        type: "ws",
        public: true,
        polarslope: coeffs[0],
        polarclo: 0,
        polarmindrag: coeffs[1],
        rangemincl: minobcl,
        rangemaxcl: maxobcl,
        s: s,
        m: m
      }
    }
      */
    // get rho for standard atmosphere
    function getrho(alt, temperatureOffset) {
        if (alt < 10000) {
            var airPressure = (0, physics_1.altitudeToPressure)(alt);
            var temperature = temperatureOffset ? (0, physics_1.temp)(alt) + temperatureOffset : (0, physics_1.temp)(alt);
            return airPressure / (physics_1.gasConst / physics_1.mmAir) / temperature;
        }
        else if (alt < 80000) { //10000 - 80000 meters
            var alts = [10000, 15000, 20000, 25000, 30000, 40000, 50000, 60000, 70000, 80000];
            var rhos = [0.4135, 0.1948, 0.1948, 0.08891, 0.04008, 0.01841, 0.003996, 0.001027, 0.0003097, 0.00008283, 0.00001846];
            var top_1 = alts.findIndex(function (talt) { return talt > alt; });
            var bottom = top_1 - 1;
            var alpha = (alt - alts[bottom]) / (alts[top_1] - alts[bottom]);
            //console.log('alt',alt,alts[bottom],alts[top],alpha,rhos[bottom]*(1-alpha)+rhos[top]*alpha)
            return rhos[bottom] * (1 - alpha) + rhos[top_1] * alpha;
        }
        else if (alt < 1000000) {
            var bottom = 0.00001846;
            var top_2 = 1.67 * Math.pow(10, -27) * 4;
            var alpha = (alt - 80000) / (1000000 - 80000);
            return bottom * (1 - alpha) + top_2 * alpha;
        }
        return 1.67 * Math.pow(10, -27) * 4;
    }
    exports.getrho = getrho;
    // get standard atmosphere for a given density
    // sort of inefficient, should be able to calculate it...
    function getStandardAtmosphere(rho) {
        var l = -10000; //-10000 // bottom -10k meters
        var r = 100000; // top -100k meters
        while (l < r) {
            var m = l + (r - l) / 2;
            var testdens = getrho(m);
            // Check if x is present at mid
            if (Math.abs(rho - testdens) < .0001) {
                return m;
            }
            //console.log(m)
            // If x greater, ignore left half
            if (rho < testdens) {
                l = m;
            }
            // If x is smaller, ignore right half
            else {
                r = m;
            }
        }
        // if we reach here, then element was
        // not present
        return -1;
    }
    exports.getStandardAtmosphere = getStandardAtmosphere;
    //
    function getS(ht) {
        // TODO: get suit specific c
        var c = 0.568888889;
        return c * ht * ht;
    }
    exports.getS = getS;
    // getcoefficients takes a number between 0 and 1, polar, rho and returns coefficients
    // on the linear seperation polar, or speed polar (stall is ignored)
    function getcoefficients(speed, polar) {
        // handle lookup table first
        // linear interpolation between points
        if (polar.table) {
            var ifl = Math.floor(speed * (polar.table.length - 1));
            var icl = Math.ceil(speed * (polar.table.length - 1));
            var cb = polar.table[ifl];
            var ct = polar.table[icl];
            var i = speed * (polar.table.length - 1) - ifl;
            var cf = {
                cl: cb.cl + i * (ct.cl - cb.cl),
                cd: cb.cd + i * (ct.cd - cb.cd)
            };
            // console.log(Math.floor(speed*polar.table.length-1),speeds)
            return cf;
        }
        // continuious polars need to index stall with drag and middle and speed with lift
        var cl;
        var cd;
        //  Do linear polar first and overwrite values for other cases
        cl = polar.rangemaxcl - speed * (polar.rangemaxcl - polar.rangemincl);
        cd = polar.polarslope * Math.pow(cl - polar.polarclo, 2) + polar.polarmindrag;
        // speed
        if (polar.clspeed && polar.cdspeed && polar.clspeedsep && polar.cdspeedsep) { // if speed polar is defined
            var indexatsep = (polar.rangemaxcl - polar.clspeedsep) / (polar.rangemaxcl - polar.rangemincl);
            if (speed > indexatsep) { // use speed polar
                // get slope from standard form
                var speedslope = (polar.clspeedsep - polar.clspeed) / Math.pow(polar.cdspeedsep - polar.cdspeed, 2);
                // get 0 lift point
                // let maxspdcl = polar.clspeed + Math.sqrt(polar.clspeed / speedslope)// may be <0?
                var speedindex = (speed - indexatsep) / (1 - indexatsep); // 1- speed/indexatsep
                cl = polar.clspeedsep - speedindex * (polar.clspeedsep - polar.rangemincl);
                cd = speedslope * Math.pow(cl - polar.clspeed, 2) + polar.cdspeed;
            }
        }
        /*
        // stall polar dont use in this case
        if (polar.clstallsep && polar.cdstallsep && polar.clstall && polar.cdstall && polar.stallmaxdrag) {// if stall point is defined
          // find index at seperation point
          const indexatsep = (polar.clstall - polar.clstallsep) / (polar.rangemaxcl - polar.rangemincl)
          if (speed < indexatsep) {// use stall polar
            // get slope from standard form
            const stallslope = (polar.clstallsep - polar.clstall) / Math.pow(polar.cdstallsep - polar.cdstall, 2)
            // re index stall range
            const stallindex = 1 - speed / indexatsep // 1- speed/indexatsep
            // get cd
            cd = polar.cdstallsep + (polar.stallmaxdrag - polar.cdstallsep) * stallindex
            // get cl
            cl = stallslope * Math.pow(cd - polar.cdstall, 2) + polar.clstall
            // console.log('indexes',speed,stallindex,indexatsep,stallslope,cd,polar.clstallsep,polar.clstall,polar.cdstallsep,polar.cdstall)
          }
        }*/
        return { cl: cl, cd: cd };
    }
    exports.getcoefficients = getcoefficients;
    function indexcoefarray(speed, arr) {
        if (speed >= 1)
            return { cl: arr[arr.length - 1].cl, cd: arr[arr.length - 1].cd };
        if (speed <= 0)
            return { cl: arr[0].cl, cd: arr[0].cd };
        var ifl = Math.floor(speed * (arr.length - 1));
        var icl = ifl + 1; //Math.ceil(speed * (polar.table.length - 1))
        var cb = arr[ifl];
        var ct = arr[icl];
        // const alpha = speed * (polar.table.length - 1) / (icl - ifl)
        var i = speed * (arr.length - 1) - ifl;
        return {
            cl: cb.cl + i * (ct.cl - cb.cl),
            cd: cb.cd + i * (ct.cd - cb.cd)
        };
    }
    function indexstallarray(speed, arr) {
        if (speed <= -1)
            return { cl: arr[0].cl, cd: arr[0].cd };
        if (speed <= 0)
            return { cl: arr[arr.length - 1].cl, cd: arr[arr.length - 1].cd };
        var ifl = Math.floor((speed + 1) * (arr.length - 1));
        var icl = ifl + 1; //Math.ceil(speed * (polar.table.length - 1))
        var cb = arr[ifl];
        var ct = arr[icl];
        // const alpha = speed * (polar.table.length - 1) / (icl - ifl)
        var i = (speed + 1) * (arr.length - 1) - ifl;
        return {
            cl: cb.cl + i * (ct.cl - cb.cl),
            cd: cb.cd + i * (ct.cd - cb.cd)
        };
    }
    // getspeed takes a number between 0 and 1, polar, rho and returns sustained speeds
    // can be used with a polar of any shape
    // numbers less than 0 map to the stall polar
    function getspeed(speed, polar, rho) {
        // can be used with a polar of any shape
        // handle lookup table first
        // linear interpolation between points
        if (polar.stallpoint) {
            if (speed < 0) {
                //check if stall point data exists
                var cf = indexstallarray(speed, polar.stallpoint);
                var speeds_1 = coefftoss(cf.cl, cf.cd, polar.s, polar.m, rho);
                return speeds_1;
            }
        }
        if (polar.table) {
            var cf = void 0;
            if (speed >= 1) {
                cf = polar.table[polar.table.length - 1];
            }
            else if (speed <= 0) {
                cf = polar.table[0];
            }
            else {
                cf = indexcoefarray(speed, polar.table);
            }
            var speeds_2 = coefftoss(cf.cl, cf.cd, polar.s, polar.m, rho);
            // console.log(polar.m)
            // console.log(Math.floor(speed*polar.table.length-1),speeds)
            return speeds_2;
        }
        // continuious polars need to index stall with drag and middle and speed with lift
        var cl;
        var cd;
        //  Do linear polar first and overwrite values for other cases
        cl = polar.rangemaxcl - speed * (polar.rangemaxcl - polar.rangemincl);
        // const acl = polar.rangemincl*speed+polar.rangemaxcl*(1-speed)
        // console.log(cl,acl)
        cd = polar.polarslope * Math.pow(cl - polar.polarclo, 2) + polar.polarmindrag;
        // speed
        if (polar.clspeed && polar.cdspeed && polar.clspeedsep && polar.cdspeedsep) { // if speed polar is defined
            var indexatsep = (polar.rangemaxcl - polar.clspeedsep) / (polar.rangemaxcl - polar.rangemincl);
            if (speed > indexatsep) { // use speed polar
                // get slope from standard form
                var speedslope = (polar.clspeedsep - polar.clspeed) / Math.pow(polar.cdspeedsep - polar.cdspeed, 2);
                // get 0 lift point
                // let maxspdcl = polar.clspeed + Math.sqrt(polar.clspeed / speedslope)// may be <0?
                var speedindex = (speed - indexatsep) / (1 - indexatsep); // 1- speed/indexatsep
                cl = polar.clspeedsep - speedindex * (polar.clspeedsep - polar.rangemincl);
                cd = speedslope * Math.pow(cl - polar.clspeed, 2) + polar.cdspeed;
            }
        }
        // stall polar
        if (polar.clstallsep && polar.cdstallsep && polar.clstall && polar.cdstall && polar.stallmaxdrag) { // if stall point is defined
            // find index at seperation point
            var indexatsep = (polar.clstall - polar.clstallsep) / (polar.rangemaxcl - polar.rangemincl);
            if (speed < indexatsep) { // use stall polar
                // get slope from standard form
                var stallslope = (polar.clstallsep - polar.clstall) / Math.pow(polar.cdstallsep - polar.cdstall, 2);
                // re index stall range
                var stallindex = 1 - speed / indexatsep; // 1- speed/indexatsep
                // get cd
                cd = polar.cdstallsep + (polar.stallmaxdrag - polar.cdstallsep) * stallindex;
                // get cl
                cl = stallslope * Math.pow(cd - polar.cdstall, 2) + polar.clstall;
                // console.log('indexes',speed,stallindex,indexatsep,stallslope,cd,polar.clstallsep,polar.clstall,polar.cdstallsep,polar.cdstall)
            }
        }
        var k = .5 * rho * polar.s / polar.m;
        var kl = cl * k / physics_1.gravity;
        var kd = cd * k / physics_1.gravity;
        var speeds = {
            vys: kd / Math.pow(kl * kl + kd * kd, .75),
            vxs: kl / Math.pow(kl * kl + kd * kd, .75)
        };
        return speeds;
    }
    exports.getspeed = getspeed;
    function getspeedbetween(vs, bottomi, topi, polar, rho) {
        //first check bounds and invert if needed
        var tops = getspeed(topi, polar, rho);
        var topvs = Math.sqrt(tops.vxs * tops.vxs + tops.vys * tops.vys);
        var bottoms = getspeed(bottomi, polar, rho);
        var bottomvs = Math.sqrt(bottoms.vxs * bottoms.vxs + bottoms.vys * bottoms.vys);
        var l, r;
        if (bottomvs < topvs) {
            l = bottomi;
            r = topi;
        }
        else {
            r = bottomi;
            l = topi;
        }
        //check for range
        if (Math.abs(vs) <= Math.min(topvs, bottomvs) || Math.abs(vs) >= Math.max(topvs, bottomvs)) {
            return {
                vs: -1,
                index: -1
            };
        }
        while (l < r) {
            var m = l + (r - l) / 2;
            var speedx = getspeed(m, polar, rho);
            var tot = Math.pow(speedx.vxs * speedx.vxs + speedx.vys * speedx.vys, .5);
            // Check if x is present at mid
            if (Math.abs(tot - vs) < .1) {
                return { vs: tot, index: m };
            }
            //console.log("looping", "l", l, "r", r)
            // If x greater, ignore smaller half
            if (vs > tot) {
                l = m;
            }
            // If x is smaller, ignore larger half
            else {
                r = m;
            }
        }
        // if we reach here, then element was
        // not present
        return {
            vs: -1,
            index: -1
        };
    }
    exports.getspeedbetween = getspeedbetween;
    function getspeedsbetween(vs, bottomi, topi, polar, rho) {
        //first check bounds and invert if needed
        var tops = getspeed(topi, polar, rho);
        var topvs = Math.sqrt(tops.vxs * tops.vxs + tops.vys * tops.vys);
        var bottoms = getspeed(bottomi, polar, rho);
        var bottomvs = Math.sqrt(bottoms.vxs * bottoms.vxs + bottoms.vys * bottoms.vys);
        var l, r;
        if (bottomvs < topvs) {
            l = bottomi;
            r = topi;
        }
        else {
            r = bottomi;
            l = topi;
        }
        //check for range
        if (Math.abs(vs) <= Math.min(topvs, bottomvs) || Math.abs(vs) >= Math.max(topvs, bottomvs)) {
            return {
                ss: { vxs: -1, vys: -1 },
                index: -1
            };
        }
        while (l < r) {
            var m = l + (r - l) / 2;
            var speedx = getspeed(m, polar, rho);
            var tot = Math.pow(speedx.vxs * speedx.vxs + speedx.vys * speedx.vys, .5);
            // Check if x is present at mid
            if (Math.abs(tot - vs) < .1) {
                return { ss: speedx, index: m };
            }
            //console.log("looping", "l", l, "r", r)
            // If x greater, ignore smaller half
            if (vs > tot) {
                l = m;
            }
            // If x is smaller, ignore larger half
            else {
                r = m;
            }
        }
        // if we reach here, then element was
        // not present
        return {
            ss: { vxs: -1, vys: -1 },
            index: -1
        };
    }
    exports.getspeedsbetween = getspeedsbetween;
    function getspeeddirty(speedindex, polar, rho, dirty) {
        var sus = getspeed(speedindex, polar, rho);
        var currentvs = Math.sqrt(sus.vxs * sus.vxs + sus.vys * sus.vys);
        var vssq = currentvs * currentvs;
        var currentlds = sus.vxs / sus.vys * dirty;
        var ldssq = currentlds * currentlds;
        sus.vxs = Math.sqrt(vssq / (1 + 1 / ldssq));
        sus.vys = Math.sqrt(vssq / (ldssq + 1));
        return sus;
    }
    exports.getspeeddirty = getspeeddirty;
    // getmax speed returns max speed
    function getmaxspeed(polar, rho) {
        var cl = polar.rangemincl;
        var cd = polar.polarslope * Math.pow(cl - polar.polarclo, 2) + polar.polarmindrag;
        var k = .5 * rho * polar.s / polar.m;
        var kl = cl * k / physics_1.gravity;
        var kd = cd * k / physics_1.gravity;
        var speeds = {
            vys: kd / Math.pow(kl * kl + kd * kd, .75),
            vxs: kl / Math.pow(kl * kl + kd * kd, .75)
        };
        return speeds;
    }
    exports.getmaxspeed = getmaxspeed;
    // getmin speed returns min speed
    function getminspeed(polar, rho) {
        var cl = polar.rangemaxcl;
        var cd = polar.polarslope * Math.pow(cl - polar.polarclo, 2) + polar.polarmindrag;
        if (polar.clstallsep && polar.cdstallsep && polar.clstall && polar.cdstall && polar.stallmaxdrag) {
            // get slope from standard form
            var stallslope = (polar.clstallsep - polar.clstall) / Math.pow(polar.cdstallsep - polar.cdstall, 2);
            cd = polar.stallmaxdrag;
            cl = stallslope * Math.pow(cd - polar.cdstall, 2) + polar.clstall;
        }
        var k = .5 * rho * polar.s / polar.m;
        var kl = cl * k / physics_1.gravity;
        var kd = cd * k / physics_1.gravity;
        var speeds = {
            vys: kd / Math.pow(kl * kl + kd * kd, .75),
            vxs: kl / Math.pow(kl * kl + kd * kd, .75)
        };
        return speeds;
    }
    exports.getminspeed = getminspeed;
    // getmaxg  uses standard form of max glide from quadratic
    function getmaxg(polar, rho) {
        if (polar.stallpoint) {
            var maxg = polar.stallpoint.reduce(function (a, b) { return a.cl / a.cd > b.cl / b.cd ? a : b; });
            return coefftoss(maxg.cl, maxg.cd, polar.s, polar.m, rho);
        }
        if (polar.table) { // discrete
            var maxg = polar.table.reduce(function (a, b) { return a.cl / a.cd > b.cl / b.cd ? a : b; });
            var k_1 = .5 * rho * polar.s / polar.m;
            var kl_1 = maxg.cl * k_1 / physics_1.gravity;
            var kd_1 = maxg.cd * k_1 / physics_1.gravity;
            var speeds_3 = {
                vys: kd_1 / Math.pow(kl_1 * kl_1 + kd_1 * kd_1, .75),
                vxs: kl_1 / Math.pow(kl_1 * kl_1 + kd_1 * kd_1, .75)
            };
            // console.log("\t" + "getmaxg" + "\t" + speeds.vxs * 2.237 + "\t" + speeds.vys * 2.237 + "\t" + speeds.vxs / speeds.vys)
            return speeds_3;
        }
        // continuious
        if (polar.clstallsep && polar.cdstallsep && polar.clstall && polar.cdstall && polar.stallmaxdrag) { // if stall is defined
            if (polar.clstallsep === polar.rangemincl) {
                return samplemaxg(polar, rho);
            } // if stallpolar is the only polar sample it
        } /*
        if (polar.clspeed && polar.cdspeed && polar.clspeedsep && polar.cdspeedsep) {// if speed polar is defined
          const speedslope = (polar.clspeedsep - polar.clspeed) / Math.pow(polar.cdspeedsep - polar.cdspeed, 2)
          const clf = Math.pow(polar.clspeed * polar.clspeed + polar.cdspeed / speedslope, .5)
        const cdf = speedslope * Math.pow(clf - polar.clspeed, 2) + polar.cdspeed
        }
        */
        var cl = Math.pow(polar.polarclo * polar.polarclo + polar.polarmindrag / polar.polarslope, .5);
        var cd = polar.polarslope * Math.pow(cl - polar.polarclo, 2) + polar.polarmindrag;
        var k = .5 * rho * polar.s / polar.m;
        var kl = cl * k / physics_1.gravity;
        var kd = cd * k / physics_1.gravity;
        var speeds = {
            vys: kd / Math.pow(kl * kl + kd * kd, .75),
            vxs: kl / Math.pow(kl * kl + kd * kd, .75)
        };
        return speeds;
    }
    exports.getmaxg = getmaxg;
    // getspeedtofly
    function getspeedtofly(polar, rho, windvx, windvd) {
        if (polar.stallpoint && polar.aoas) { /// discrete
            var k = .5 * rho * polar.s / polar.m;
            var bottom = 0;
            var top_3 = 0;
            //let top = polar.stallpoint.length
            var best = { vxs: .0001, vys: 1 };
            for (var index = 0; index < polar.stallpoint.length; index++) {
                var aoa = polar.aoas[index];
                if (aoa > 0 && aoa < 90) {
                    var ai = polar.stallpoint[index];
                    var akl = ai.cl * k / physics_1.gravity;
                    var akd = ai.cd * k / physics_1.gravity;
                    var a = {
                        vys: akd / Math.pow(akl * akl + akd * akd, .75) + windvd,
                        vxs: akl / Math.pow(akl * akl + akd * akd, .75) + windvx
                    };
                    if (a.vxs / a.vys > best.vxs / best.vys) {
                        best = a;
                        bottom = index - 1 > 0 ? index - 1 : index;
                        top_3 = index + 1 > 0 ? index + 1 : index;
                    }
                }
            }
            //console.log(bottom,top,best)
            return best;
            return samplespeedtoflytable(bottom, top_3, polar, rho, windvx, windvd);
        }
        //
        if (polar.table) { /// discrete
            var k_2 = .5 * rho * polar.s / polar.m;
            return polar.table.map(function (a) {
                var akl = a.cl * k_2 / physics_1.gravity;
                var akd = a.cd * k_2 / physics_1.gravity;
                var awspeeds = {
                    vys: akd / Math.pow(akl * akl + akd * akd, .75) + windvd,
                    vxs: akl / Math.pow(akl * akl + akd * akd, .75) + windvx
                };
                return awspeeds;
            }).reduce(function (a, b) { return a.vxs / a.vys > b.vxs / b.vys ? a : b; });
        }
        /*
          // fit quadratic to sampled coefficients and use standard  form to solve for wind adj max glide?
          if (polar.table) {
            const k = .5 * rho * polar.s / polar.m
            // get wind adjusted polar cl cd []
            const wcoef = polar.table.map((a) => {
              const akl = a.cl * k / 9.8
              const akd = a.cd * k / 9.8
              const awspeeds: SustainedSpeeds = {
                vys: (akd / Math.pow(akl * akl + akd * akd, .75)) + windvd,
                vxs: (akl / Math.pow(akl * akl + akd * akd, .75)) + windvx
              }
              const total2 = awspeeds.vxs * awspeeds.vxs + awspeeds.vys * awspeeds.vys
              const totalFactor = Math.pow(total2, 1.5)
              const wkl = awspeeds.vxs / totalFactor
              const wkd = awspeeds.vys / totalFactor
              const coeffs: Coefficients = {
                cl: wkl / k * 9.8,
                cd: wkd / k * 9.8
              }
              return coeffs
            })
            // fit slope intercept
            // sample polar around max glide point
      
            let smg = 0
            let ind = 0
            for (let i = 0; i < wcoef.length; i++){
              const coef = wcoef[i]
              const gr = coef.cl / coef.cd
              if (gr > smg){
                smg = gr
                ind = i
              }
            }
            const swcoeff = wcoef.slice(ind - 3, ind + 4)
            const pcs = getSlopeInt(swcoeff, (d) => d.cl * d.cl, (d) => d.cd)
            const maxobcl = Math.max.apply(Math, swcoeff.map(function (o) { return o.cl }))
            const minobcl = Math.min.apply(Math, swcoeff.map(function (o) { return o.cl }))
            const wp: WSEQPolar = {
              name: "windpolar",
              polarslope: pcs[0],
              polarclo: 0,
              polarmindrag: pcs[1],
              rangemincl: minobcl,
              rangemaxcl: maxobcl,
              s: polar.s,
              m: polar.m
            }
            return getmaxg(wp, rho)
          }*/
        else { // continuious*/
            //const maxgcalm = getmaxg(polar, rho)
            return samplespeedtofly(polar, rho, windvx, windvd); // broke
            // }
        }
    }
    exports.getspeedtofly = getspeedtofly;
    // getsustained finds the sustained speeds for a given vs
    function getsustained(vs, polar, rho) {
        var l = 0;
        var r = 1;
        while (l < r) {
            var m = l + (r - l) / 2;
            var speedx = getspeed(m, polar, rho);
            var tot = Math.pow(speedx.vxs * speedx.vxs + speedx.vys * speedx.vys, .5);
            // Check if x is present at mid
            if (Math.abs(tot - vs) < .1) {
                return speedx;
            }
            // If x greater, ignore left half
            if (vs > tot) {
                l = m;
            }
            // If x is smaller, ignore right half
            else {
                r = m;
            }
        }
        // if we reach here, then element was
        // not present
        return {
            vys: -1,
            vxs: -1
        };
    }
    exports.getsustained = getsustained;
    // getsustained finds the sustained speeds for a given vs
    function getsustainedindex(vs, polar, rho) {
        var l = 0;
        var r = 1;
        while (l < r) {
            var m = l + (r - l) / 2;
            var speedx = getspeed(m, polar, rho);
            var tot = Math.pow(speedx.vxs * speedx.vxs + speedx.vys * speedx.vys, .5);
            // Check if x is present at mid
            if (Math.abs(tot - vs) < .1) {
                return { ss: speedx, n: m };
            }
            // If x greater, ignore left half
            if (vs > tot) {
                l = m;
            }
            // If x is smaller, ignore right half
            else {
                r = m;
            }
        }
        // if we reach here, then element was
        // not present
        //console.log("binarysearch",l,"l",r,"r",vs)
        // can return the end element
        return {
            ss: {
                vys: -1,
                vxs: -1
            },
            n: -1
        };
    }
    exports.getsustainedindex = getsustainedindex;
    // getsustained finds the sustained speeds for a given gr
    function getgrindex(tgr, polar, descending) {
        var l = 0;
        var r = 1;
        while (l < r) {
            var m = l + (r - l) / 2;
            var cl = polar.rangemaxcl - m * (polar.rangemaxcl - polar.rangemincl);
            var cd = polar.polarslope * Math.pow(cl - polar.polarclo, 2) + polar.polarmindrag;
            var gr = cl / cd;
            // Check if x is present at mid
            if (Math.abs(gr - tgr) < .00001) {
                return { c: { cl: cl, cd: cd }, n: m };
            }
            if (descending) {
                if (gr < tgr) {
                    r = m;
                }
                else {
                    l = m;
                }
            }
            else {
                if (gr > tgr) {
                    r = m;
                }
                else {
                    l = m;
                }
            }
        }
        // if we reach here, then element was
        // not present
        //console.log("binarysearch",l,"l",r,"r",vs)
        // can return the end element
        return {
            c: {
                cl: -1,
                cd: -1
            },
            n: -1
        };
    }
    exports.getgrindex = getgrindex;
    // getsustained finds the sustained speeds for a given vxs
    function getvys(vxs, polar, rho) {
        var l = 0;
        var r = 1;
        while (l < r) {
            var m = l + (r - l) / 2;
            var speedx = getspeed(m, polar, rho);
            // Check if x is present at mid
            if (Math.abs(speedx.vxs - vxs) < .1) {
                return speedx;
            }
            // If x greater, ignore left half
            if (vxs > speedx.vxs) {
                l = m;
            }
            // If x is smaller, ignore right half
            else {
                r = m;
            }
        }
        // if we reach here, then element was
        // not present
        return {
            vys: -1,
            vxs: -1
        };
    }
    exports.getvys = getvys;
    function samplemaxg(polar, rho) {
        var l = 0;
        var r = 1;
        var maxg = 0;
        var oldmaxg = 0;
        while (l < r) {
            var m = l + (r - l) / 2;
            var speedm = getspeed(m, polar, rho);
            var dm = getspeed(m + .001, polar, rho);
            var gm = speedm.vxs / speedm.vys;
            maxg = gm;
            var gdm = dm.vxs / dm.vys;
            var ignoreleft = false;
            if (gdm > gm) {
                ignoreleft = true;
            }
            else {
                ignoreleft = false;
            }
            // const tot = Math.pow(speedx.vxs * speedx.vxs + speedx.vys * speedx.vys, .5)
            // const ldm = speedm.vxs/speedm.vys
            // console.log(ignoreleft,speedm)
            // Check if x is present at mid
            if (Math.abs(maxg - oldmaxg) < .01) {
                return speedm;
            }
            oldmaxg = maxg;
            // If x greater, ignore left half
            if (ignoreleft) {
                l = m;
            }
            // If x is smaller, ignore right half
            else {
                r = m;
            }
        }
        // if we reach here, then element was
        // not present
        return {
            vys: -1,
            vxs: -1
        };
    }
    exports.samplemaxg = samplemaxg;
    // broken but im still using
    function samplespeedtofly(polar, rho, windvx, windvd) {
        var l = 0;
        var r = 1;
        var count = 0;
        var maxg = 0;
        var oldmaxg = 0;
        var oomg = 0;
        while (l < r) {
            count = count + 1;
            var m = l + (r - l) / 2;
            var speedm = getspeed(m, polar, rho);
            var dm = getspeed(m + .00001, polar, rho);
            var gm = (speedm.vxs + windvx) / (speedm.vys + windvd);
            maxg = gm;
            var gdm = (dm.vxs + windvx) / (dm.vys + windvd);
            var ignoreleft = false;
            if (gdm > gm) {
                ignoreleft = true;
            }
            else {
                ignoreleft = false;
            }
            // const tot = Math.pow(speedx.vxs * speedx.vxs + speedx.vys * speedx.vys, .5)
            // const ldm = speedm.vxs/speedm.vys
            // console.log(ignoreleft,speedm)
            // Check if x is present at mid
            if (Math.abs(maxg - oldmaxg) < .0001 && Math.abs(maxg - oomg) < .0001 || count > 1000) { // this is where its wrong
                //console.log(count)
                return { vxs: speedm.vxs + windvx, vys: speedm.vys + windvd };
            }
            oomg = oldmaxg;
            oldmaxg = maxg;
            // If x greater, ignore left half
            if (ignoreleft) {
                l = m;
            }
            // If x is smaller, ignore right half
            else {
                r = m;
            }
        }
        // if we reach here, then element was
        // not present
        return {
            vys: -1,
            vxs: -1
        };
    }
    exports.samplespeedtofly = samplespeedtofly;
    // broken but im still using
    function samplespeedtoflytable(bottom, top, polar, rho, windvx, windvd) {
        if (polar.aoas) {
            var l = polar.aoas[bottom];
            var r = polar.aoas[top];
            var count = 0;
            var maxg = 0;
            var oldmaxg = 0;
            var oomg = 0;
            while (l > r) {
                count = count + 1;
                var m = r + (l - r) / 2;
                var speedm = (0, polar_library_1.aoatospeed)(m, polar, rho);
                var dm = (0, polar_library_1.aoatospeed)(m - .001, polar, rho);
                var gm = (speedm.vxs + windvx) / (speedm.vys + windvd);
                maxg = gm;
                var gdm = (dm.vxs + windvx) / (dm.vys + windvd);
                var ignoreleft = false;
                if (gdm > gm) {
                    ignoreleft = true;
                }
                else {
                    ignoreleft = false;
                }
                // const tot = Math.pow(speedx.vxs * speedx.vxs + speedx.vys * speedx.vys, .5)
                // const ldm = speedm.vxs/speedm.vys
                //console.log(ignoreleft, speedm, dm)
                // Check if x is present at mid
                if (Math.abs(maxg - oldmaxg) < .0001 && Math.abs(maxg - oomg) < .0001 || count > 1000) { // this is where its wrong
                    //console.log(count)
                    return { vxs: speedm.vxs + windvx, vys: speedm.vys + windvd };
                }
                oomg = oldmaxg;
                oldmaxg = maxg;
                // If x greater, ignore left half
                if (ignoreleft) {
                    l = m;
                }
                // If x is smaller, ignore right half
                else {
                    r = m;
                }
            }
        }
        // if we reach here, then element was
        // not present
        return {
            vys: -1,
            vxs: -1
        };
    }
    exports.samplespeedtoflytable = samplespeedtoflytable;
    // getsustained finds the min sink
    // export function getminsinkcheap(polar: WSEQPolar): Coefficients{
    // return coeff
    // }
    // get wsaoa or canopy aoa in rad
    function getwsaoafromss(vxs, vys, polar, rho) {
        var kl = vxs / Math.pow(vxs * vxs + vys * vys, 1.5);
        var kd = vys / Math.pow(vxs * vxs + vys * vys, 1.5);
        var k = .5 * rho * polar.s / polar.m;
        var cl = kl / k * physics_1.gravity;
        var cd = kd / k * physics_1.gravity;
        // todo change to use limits(35,0)maxg(10) and minsink (20)?
        if (cl > 1.4) { // canopy
            return (90 + 3 * Math.exp(.3 * cl)) * Math.PI / 180;
        }
        else { // ws
            return (35 * Math.sqrt(cl * cl + cd * cd) + .0044) * Math.PI / 180;
        }
    }
    exports.getwsaoafromss = getwsaoafromss;
    //export function
    // input aoa in rad not working yet, dont use
    function getssfromwsaoa(aoa, polar, rho) {
        var l = 0;
        var r = 1;
        while (l < r) {
            var m = l + (r - l) / 2;
            var speedx = getspeed(m, polar, rho);
            var aoax = getwsaoafromss(speedx.vxs, speedx.vys, polar, rho);
            // Check if x is present at mid
            if (Math.abs(aoax - aoa) < .1) {
                return speedx;
            }
            // If x greater, ignore left half
            if (aoa > aoax) {
                l = m;
            }
            // If x is smaller, ignore right half
            else {
                r = m;
            }
        }
        // if we reach here, then element was
        // not present
        return { vys: -1, vxs: -1 };
    }
    exports.getssfromwsaoa = getssfromwsaoa;
    // const ss: SustainedSpeeds[] = [{ vxs: 5, vys: 4 }, { vxs: 5, vys: 4 }]
    // get slick
    function getslickaoafromss(vxs, vys, polar, alt) {
        var rho = getrho(alt);
        var kd = vys / Math.pow(vxs * vxs + vys * vys, 1.5);
        var k = .5 * rho * polar.s / polar.m;
        var cd = kd / k * physics_1.gravity;
        if (polar.clstallsep && polar.clstall && polar.cdstallsep && polar.cdstall) {
            // get slope
            var stallslope = polar.clstallsep - polar.clstall / Math.pow(polar.cdstallsep - polar.cdstall, 2);
            // get 0 lift point vxs = 0
            var fullstallcd = polar.cdstall + Math.sqrt(-polar.clstall / stallslope); // may be <0?
            //
            return 90 * (1 - (fullstallcd - cd) / (fullstallcd - polar.cdstallsep)) * Math.PI / 180;
        }
        return -1;
    }
    exports.getslickaoafromss = getslickaoafromss;
    // not tested
    function samplePolarC(n, polar) {
        if (polar.stallpoint) {
            var pathdist = [];
            var sums = [];
            var s = coefftoss(polar.stallpoint[0].cl, polar.stallpoint[0].cd, polar.s, polar.m, 1);
            //pathdist[0] = Math.sqrt(s.vxs*s.vxs+s.vys*s.vys)
            var last = s;
            for (var index = 0; index < polar.stallpoint.length; index++) {
                var c = polar.stallpoint[index];
                var ssout = coefftoss(c.cl, c.cd, polar.s, polar.m, 1);
                pathdist[index] = Math.sqrt((ssout.vxs - last.vxs) * (ssout.vxs - last.vxs) + (ssout.vys - last.vys) * (ssout.vys - last.vys));
                var prev = index == 0 ? 0 : sums[index - 1];
                sums[index] = prev + pathdist[index];
                last = ssout;
            }
            var range = sums[pathdist.length - 1];
            var increment = range / n;
            var ss = [];
            var curdist_1 = 0;
            for (var index = 0; index < n; index++) {
                var top_4 = sums.findIndex(function (d) { return d > curdist_1; });
                if (top_4 > pathdist.length - 1)
                    top_4 = pathdist.length - 1;
                var bottom = top_4 - 1;
                var alpha = (curdist_1 - sums[bottom]) / (sums[top_4] - sums[bottom]);
                var cl = polar.stallpoint[bottom].cl * (1 - alpha) + polar.stallpoint[top_4].cl * alpha;
                var cd = polar.stallpoint[bottom].cd * (1 - alpha) + polar.stallpoint[top_4].cd * alpha;
                ss[index] = { cl: cl, cd: cd };
                curdist_1 += increment;
                //console.log(alpha,sums[bottom],sums[top],sums)
            }
            // console.log(ss,pathdist,sums,range,increment)
            return ss;
        }
        var begin = getspeed(0, polar, 1);
        var end = getspeed(1, polar, 1);
        var minspeed = Math.pow(begin.vxs * begin.vxs + begin.vys * begin.vys, .5);
        var maxspeed = Math.pow(end.vxs * end.vxs + end.vys * end.vys, .5);
        // console.log(polar, minspeed, maxspeed)
        var sampled = [];
        var current = 0;
        while (current < n) {
            // console.log(minspeed + current / (n - 1) * (maxspeed - minspeed),)
            sampled.push(getcoefficients(minspeed + current / (n - 1) * (maxspeed - minspeed), polar));
            // console.log(sampled)
            current = current + 1;
        }
        return sampled;
    }
    exports.samplePolarC = samplePolarC;
    function samplePolartable(n, stallpoint, d) {
        var pathdist = [];
        var sums = [];
        var s = coefftoss(stallpoint[0].cl, stallpoint[0].cd, 2, 77, 1);
        //pathdist[0] = Math.sqrt(s.vxs*s.vxs+s.vys*s.vys)
        var last = s;
        for (var index = 0; index < stallpoint.length; index++) {
            var c = stallpoint[index];
            var speedpolarstallpoint = coefftoss(c.cl, c.cd, 2, 77, 1);
            pathdist[index] = Math.sqrt((speedpolarstallpoint.vxs - last.vxs) * (speedpolarstallpoint.vxs - last.vxs) + (speedpolarstallpoint.vys - last.vys) * (speedpolarstallpoint.vys - last.vys));
            var prev = index == 0 ? 0 : sums[index - 1];
            sums[index] = prev + pathdist[index];
            last = speedpolarstallpoint;
        }
        var range = sums[pathdist.length - 1];
        var increment = range / n;
        var ss = [];
        var curdist = 0;
        for (var index = 0; index < n; index++) {
            var top_5 = sums.findIndex(function (t) { return t > curdist; });
            if (top_5 > pathdist.length - 1)
                top_5 = pathdist.length - 1;
            var bottom = top_5 - 1;
            var alpha = (curdist - sums[bottom]) / (sums[top_5] - sums[bottom]);
            var aoa = d[bottom] * (1 - alpha) + d[top_5] * alpha;
            ss[index] = aoa;
            curdist += increment;
            //console.log(alpha,sums[bottom],sums[top],sums)
        }
        // console.log(ss,pathdist,sums,range,increment)
        return ss;
    }
    exports.samplePolartable = samplePolartable;
    // samplepolar returns an array of n sustained speeds evenly
    // spaced across the polar
    function samplePolarColors(n, polar, rho) {
        if (polar.stallpoint && polar.aoas) {
            var pathdist = [];
            var sums = [];
            var aoas = [];
            var s = coefftoss(polar.stallpoint[0].cl, polar.stallpoint[0].cd, polar.s, polar.m, rho);
            //pathdist[0] = Math.sqrt(s.vxs*s.vxs+s.vys*s.vys)
            var last = s;
            for (var index = 0; index < polar.stallpoint.length; index++) {
                var c_1 = polar.stallpoint[index];
                var colorspeed = coefftoss(c_1.cl, c_1.cd, polar.s, polar.m, rho);
                pathdist[index] = Math.sqrt((colorspeed.vxs - last.vxs) * (colorspeed.vxs - last.vxs) + (colorspeed.vys - last.vys) * (colorspeed.vys - last.vys));
                var prev = index == 0 ? 0 : sums[index - 1];
                sums[index] = prev + pathdist[index];
                last = colorspeed;
            }
            var range = sums[pathdist.length - 1];
            var increment = range / n;
            var ss = [];
            var curdist_2 = 0;
            for (var index = 0; index < n; index++) {
                var top_6 = sums.findIndex(function (d) { return d > curdist_2; });
                if (top_6 > pathdist.length - 1)
                    top_6 = pathdist.length - 1;
                var bottom = top_6 - 1;
                var alpha = (curdist_2 - sums[bottom]) / (sums[top_6] - sums[bottom]);
                var cl = polar.stallpoint[bottom].cl * (1 - alpha) + polar.stallpoint[top_6].cl * alpha;
                var cd = polar.stallpoint[bottom].cd * (1 - alpha) + polar.stallpoint[top_6].cd * alpha;
                ss[index] = coefftoss(cl, cd, polar.s, polar.m, rho);
                var aoa = polar.aoas[bottom] * (1 - alpha) + polar.aoas[top_6] * alpha;
                aoas[index] = aoa; //aoamodelcolor(0, aoa)
                curdist_2 += increment;
                //console.log(alpha,sums[bottom],sums[top],sums)
            }
            var c = [];
            for (var i = 0; i < aoas.length - 1; i++) {
                c.push({ mode: aoamodelcolor(0, (aoas[i] + aoas[i + 1]) / 2), data: [ss[i], ss[i + 1]] });
            }
            // console.log(ss,pathdist,sums,range,increment)
            //console.log("Colored new",ss,c)
            return { ss: ss, c: c };
        }
        var begin = getspeed(0, polar, rho);
        var end = getspeed(1, polar, rho);
        var minspeed = Math.pow(begin.vxs * begin.vxs + begin.vys * begin.vys, .5);
        var maxspeed = Math.pow(end.vxs * end.vxs + end.vys * end.vys, .5);
        // console.log(polar, minspeed, maxspeed)
        var sampled = [];
        var current = 0;
        while (current < n) {
            // console.log(minspeed + current / (n - 1) * (maxspeed - minspeed),)
            sampled.push(getsustained(minspeed + current / (n - 1) * (maxspeed - minspeed), polar, rho));
            // console.log(sampled)
            current = current + 1;
        }
        return { ss: sampled, c: SimulatorPolarColor(sampled) };
    }
    exports.samplePolarColors = samplePolarColors;
    // samplepolar returns an array of n sustained speeds evenly
    // spaced across the polar
    function samplePolar(n, polar, rho) {
        if (polar.stallpoint) {
            var pathdist = [];
            var sums = [];
            var s = coefftoss(polar.stallpoint[0].cl, polar.stallpoint[0].cd, polar.s, polar.m, rho);
            //pathdist[0] = Math.sqrt(s.vxs*s.vxs+s.vys*s.vys)
            var last = s;
            for (var index = 0; index < polar.stallpoint.length; index++) {
                var c = polar.stallpoint[index];
                var samplespeed = coefftoss(c.cl, c.cd, polar.s, polar.m, rho);
                pathdist[index] = Math.sqrt((samplespeed.vxs - last.vxs) * (samplespeed.vxs - last.vxs) + (samplespeed.vys - last.vys) * (samplespeed.vys - last.vys));
                var prev = index == 0 ? 0 : sums[index - 1];
                sums[index] = prev + pathdist[index];
                last = samplespeed;
            }
            var range = sums[pathdist.length - 1];
            var increment = range / n;
            var ss = [];
            var curdist_3 = 0;
            for (var index = 0; index < n; index++) {
                var top_7 = sums.findIndex(function (d) { return d > curdist_3; });
                if (top_7 > pathdist.length - 1)
                    top_7 = pathdist.length - 1;
                var bottom = top_7 - 1;
                var alpha = (curdist_3 - sums[bottom]) / (sums[top_7] - sums[bottom]);
                var cl = polar.stallpoint[bottom].cl * (1 - alpha) + polar.stallpoint[top_7].cl * alpha;
                var cd = polar.stallpoint[bottom].cd * (1 - alpha) + polar.stallpoint[top_7].cd * alpha;
                ss[index] = coefftoss(cl, cd, polar.s, polar.m, rho);
                curdist_3 += increment;
                //console.log(alpha,sums[bottom],sums[top],sums)
            }
            // console.log(ss,pathdist,sums,range,increment)
            return ss;
        }
        var begin = getspeed(0, polar, rho);
        var end = getspeed(1, polar, rho);
        var minspeed = Math.pow(begin.vxs * begin.vxs + begin.vys * begin.vys, .5);
        var maxspeed = Math.pow(end.vxs * end.vxs + end.vys * end.vys, .5);
        // console.log(polar, minspeed, maxspeed)
        var sampled = [];
        var current = 0;
        while (current < n) {
            // console.log(minspeed + current / (n - 1) * (maxspeed - minspeed),)
            sampled.push(getsustained(minspeed + current / (n - 1) * (maxspeed - minspeed), polar, rho));
            // console.log(sampled)
            current = current + 1;
        }
        return sampled;
    }
    exports.samplePolar = samplePolar;
    function polartoss(n, polar, rho) {
        return polar.table ? polar.table.map(function (c) { return coefftoss(c.cl, c.cd, polar.s, polar.m, rho); }) : samplePolar(n, polar, rho);
    }
    exports.polartoss = polartoss;
    function changetablesize(n, polar) {
        var table = [];
        if (polar.table) {
            for (var index = 0; index < n; index++) {
                var s = getspeed(index / n, polar, 1);
                var c = sstocoeff(s.vxs, s.vys, polar.s, polar.m, 1);
                table.push(c);
            }
        }
        return table;
    }
    exports.changetablesize = changetablesize;
    function coefftoss(cl, cd, s, m, rho) {
        var k = .5 * rho * s / m;
        var kl = cl * k / physics_1.gravity;
        var kd = cd * k / physics_1.gravity;
        var denom = Math.pow(kl * kl + kd * kd, 0.75);
        return { vxs: kl / denom, vys: kd / denom };
    }
    exports.coefftoss = coefftoss;
    function sstocoeff(vxs, vys, s, m, rho) {
        var k = .5 * rho * s / m;
        var denom = Math.pow(vxs * vxs + vys * vys, 1.5);
        var kl = vxs / denom;
        var kd = vys / denom;
        return { cl: kl / k * physics_1.gravity, cd: kd / k * physics_1.gravity };
    }
    exports.sstocoeff = sstocoeff;
    var AoaModel;
    (function (AoaModel) {
        AoaModel[AoaModel["WingsuitL"] = 0] = "WingsuitL";
        AoaModel[AoaModel["WingsuitS"] = 1] = "WingsuitS";
        AoaModel[AoaModel["OnePiece"] = 2] = "OnePiece";
        AoaModel[AoaModel["TwoPiece"] = 3] = "TwoPiece";
        AoaModel[AoaModel["Slick"] = 4] = "Slick";
        AoaModel[AoaModel["Canopy"] = 5] = "Canopy";
    })(AoaModel = exports.AoaModel || (exports.AoaModel = {}));
    function aoamodelcolor(modelnumber, aoa) {
        //const color = "#000000"
        var aoas = [];
        var colors = [];
        switch (modelnumber) {
            // case AoaModel.WingsuitL:
            // break;
            default:
                aoas = [0, 1.5, 3, 5, 10, 15, 20, 35, 50, 90];
                colors = [
                    "#ff00ff",
                    "#ff0000",
                    "#ff3d00",
                    "#ffa000",
                    "#ffff00",
                    "#00ff00",
                    "#00ffff",
                    "#0000ff",
                    "#a000ff",
                    "#ff00ff"
                ]; //90
                break;
        }
        if (aoa < aoas[0])
            return "#ff00ff";
        if (aoa > aoas[aoas.length - 1])
            return "#ff00ff";
        if (10.5 > aoa && aoa > 9.5)
            return "#000000";
        var top = aoas.findIndex(function (a) { return aoa < a; });
        var bottom = top - 1;
        var alpha = (aoa - aoas[bottom]) / (aoas[top] - aoas[bottom]);
        return lerpColor(colors[bottom], colors[top], alpha);
    }
    // another colorer for aoa and cp charts... not working right
    function colorByAoa(arr, model) {
        var colors = arr.map(function (p) { return aoamodelcolor(model, p.x); });
        var colorsb = [];
        for (var i = 0; i < colors.length - 1; i++) {
            //if(arr[i].x == 10)console.log("maxg",aoatosustained(arr[i].x,polar,1),colors[i],maxg.vxs)
            colorsb.push({ mode: colors[i], data: [arr[i], arr[i + 1]] });
        }
        // console.log("aoa",colorsb)
        return colorsb;
    }
    exports.colorByAoa = colorByAoa;
    // another colorer for aoa and cp charts
    function aoaPolarColor(arr, polar) {
        var colors = [];
        var color = "#000000";
        var n = arr.length;
        var samp = [];
        for (var index = 0; index < n; index++) {
            if (!polar.stallpoint) {
                samp[index] = (0, polar_library_1.aoatosustained)(arr[index].x, polar, 1).ss;
            }
            else {
                return colorByAoa(arr, 1); //samp[index] = aoatospeed(arr[index].x, polar, 1)
            }
            //if(arr[index].x == 10)console.log("maxg",aoatosustained(arr[index].x,polar,1))
        }
        // console.log (samp)
        var samp2 = samplePolar(n, polar, 1); //get normal ind for breaks
        var maxg = getmaxg(polar, 1);
        var maxvxs = samp2.reduce(function (a, b) { return a.vxs > b.vxs ? a : b; });
        var maxvys = samp2.reduce(function (a, b) { return a.vys > b.vys ? a : b; });
        var minsink = samp2.reduce(function (a, b) { return a.vys < b.vys ? a : b; });
        var stallpoint = samp[0];
        for (var i = 0; i < n; i++) {
            if (samp[i].vxs < (stallpoint.vxs + minsink.vxs) / 2 && samp[i].vys < maxvxs.vys) {
                // red goes from 0x7d to 0x00 green = 0x00 blue = 0xff
                var top_8 = (stallpoint.vxs + minsink.vxs) / 2;
                var bottom = stallpoint.vxs;
                var red = 125 - 125 * (samp[i].vxs - bottom) / (top_8 - bottom);
                var tempc = Math.round(red).toString(16).length === 1 ? "0" + Math.round(red).toString(16) : Math.round(red).toString(16);
                color = "#" + tempc + "00ff";
            }
            else if (samp[i].vxs < minsink.vxs && samp[i].vys < maxvxs.vys) {
                // red = 0x00 green goes from 0x00 to 0xff blue = 0xff
                var bottom = (stallpoint.vxs + minsink.vxs) / 2;
                var top_9 = minsink.vxs;
                var green = 255 * (samp[i].vxs - bottom) / (top_9 - bottom);
                var tempc = Math.round(green).toString(16).length === 1 ? "0" + Math.round(green).toString(16) : Math.round(green).toString(16);
                color = "#00" + tempc + "ff";
            }
            else if (samp[i].vxs < (maxg.vxs + minsink.vxs) / 2 && samp[i].vys < maxvxs.vys) {
                // red = 0x00 green = 0xff blue goes from 0xff to 0x00
                var top_10 = (maxg.vxs + minsink.vxs) / 2;
                var bottom = stallpoint.vxs;
                var blue = 255 - 255 * (samp[i].vxs - bottom) / (top_10 - bottom);
                var tempc = Math.round(blue).toString(16).length === 1 ? "0" + Math.round(blue).toString(16) : Math.round(blue).toString(16);
                color = "#00ff" + tempc;
            }
            else if (samp[i].vxs < maxg.vxs && samp[i].vys < maxvxs.vys) {
                // red goes from 0x00 to 0xff green = 0xff blue = 0x00
                var bottom = (maxg.vxs + minsink.vxs) / 2;
                var top_11 = maxg.vxs;
                var red = 255 * (samp[i].vxs - bottom) / (top_11 - bottom);
                var tempc = Math.round(red).toString(16).length === 1 ? "0" + Math.round(red).toString(16) : Math.round(red).toString(16);
                color = "#" + tempc + "ff00";
            }
            else if (samp[i].vxs < (maxg.vxs + maxvxs.vxs) / 2 && samp[i].vys < maxvxs.vys) {
                // red = 0xff green goes from 0xff to 0x7d blue = 0x00
                var top_12 = (maxg.vxs + maxvxs.vxs) / 2;
                var bottom = maxg.vxs;
                var green = 255 - 125 * (samp[i].vxs - bottom) / (top_12 - bottom);
                var tempc = Math.round(green).toString(16).length === 1 ? "0" + Math.round(green).toString(16) : Math.round(green).toString(16);
                color = "#ff" + tempc + "00";
            }
            else if (samp[i].vxs < maxvxs.vxs && samp[i].vys < maxvxs.vys) {
                // red = 0xff green goes from 0x7d to 0x00 blue = 0x00
                var top_13 = maxvxs.vxs;
                var bottom = (maxg.vxs + maxvxs.vxs) / 2;
                var green = 125 - 125 * (samp[i].vxs - bottom) / (top_13 - bottom);
                var tempc = Math.round(green).toString(16).length === 1 ? "0" + Math.round(green).toString(16) : Math.round(green).toString(16);
                color = "#ff" + tempc + "00";
            }
            else {
                // red = 0xff green = 0x00 blue goes from 0x00 to 0xff
                var top_14 = maxvys.vys;
                var bottom = maxvxs.vys;
                if (top_14 === bottom) {
                    color = "#ff0000";
                }
                else {
                    var blue = 255 * (samp[i].vys - bottom) / (top_14 - bottom);
                    color = "#ff00" + Math.round(blue).toString(16);
                }
            }
            colors.push(color);
        }
        var colorsb = [];
        for (var i = 0; i < colors.length - 1; i++) {
            //if(arr[i].x == 10)console.log("maxg",aoatosustained(arr[i].x,polar,1),colors[i],maxg.vxs)
            colorsb.push({ mode: colors[i], data: [arr[i], arr[i + 1]] });
        }
        //console.log(colorsb)
        return colorsb;
    }
    exports.aoaPolarColor = aoaPolarColor;
    // prerdiction engine
    function polarColor(n, polar) {
        var colors = [];
        var color = "#000000";
        var samp = samplePolar(n, polar, 1);
        var maxg = getmaxg(polar, 1);
        var maxvxs = samp.reduce(function (a, b) { return a.vxs > b.vxs ? a : b; });
        var maxvys = samp.reduce(function (a, b) { return a.vys > b.vys ? a : b; });
        var minsink = samp.reduce(function (a, b) { return a.vys < b.vys ? a : b; });
        var stallpoint = samp[0];
        for (var i = 0; i < n; i++) {
            if (samp[i].vxs < (stallpoint.vxs + minsink.vxs) / 2 && samp[i].vys < maxvxs.vys) {
                // red goes from 0x7d to 0x00 green = 0x00 blue = 0xff
                var top_15 = (stallpoint.vxs + minsink.vxs) / 2;
                var bottom = stallpoint.vxs;
                var red = 125 - 125 * (samp[i].vxs - bottom) / (top_15 - bottom);
                var tempc = Math.round(red).toString(16).length === 1 ? "0" + Math.round(red).toString(16) : Math.round(red).toString(16);
                color = "#" + tempc + "00ff";
            }
            else if (samp[i].vxs < minsink.vxs && samp[i].vys < maxvxs.vys) {
                // red = 0x00 green goes from 0x00 to 0xff blue = 0xff
                var bottom = (stallpoint.vxs + minsink.vxs) / 2;
                var top_16 = minsink.vxs;
                var green = 255 * (samp[i].vxs - bottom) / (top_16 - bottom);
                var tempc = Math.round(green).toString(16).length === 1 ? "0" + Math.round(green).toString(16) : Math.round(green).toString(16);
                color = "#00" + tempc + "ff";
            }
            else if (samp[i].vxs < (maxg.vxs + minsink.vxs) / 2 && samp[i].vys < maxvxs.vys) {
                // red = 0x00 green = 0xff blue goes from 0xff to 0x00
                var top_17 = (maxg.vxs + minsink.vxs) / 2;
                var bottom = stallpoint.vxs;
                var blue = 255 - 255 * (samp[i].vxs - bottom) / (top_17 - bottom);
                var tempc = Math.round(blue).toString(16).length === 1 ? "0" + Math.round(blue).toString(16) : Math.round(blue).toString(16);
                color = "#00ff" + tempc;
            }
            else if (samp[i].vxs < maxg.vxs && samp[i].vys < maxvxs.vys) {
                // red goes from 0x00 to 0xff green = 0xff blue = 0x00
                var bottom = (maxg.vxs + minsink.vxs) / 2;
                var top_18 = maxg.vxs;
                var red = 255 * (samp[i].vxs - bottom) / (top_18 - bottom);
                var tempc = Math.round(red).toString(16).length === 1 ? "0" + Math.round(red).toString(16) : Math.round(red).toString(16);
                color = "#" + tempc + "ff00";
            }
            else if (samp[i].vxs < (maxg.vxs + maxvxs.vxs) / 2 && samp[i].vys < maxvxs.vys) {
                // red = 0xff green goes from 0xff to 0x7d blue = 0x00
                var top_19 = (maxg.vxs + maxvxs.vxs) / 2;
                var bottom = maxg.vxs;
                var green = 255 - 125 * (samp[i].vxs - bottom) / (top_19 - bottom);
                var tempc = Math.round(green).toString(16).length === 1 ? "0" + Math.round(green).toString(16) : Math.round(green).toString(16);
                color = "#ff" + tempc + "00";
            }
            else if (samp[i].vxs < maxvxs.vxs && samp[i].vys < maxvxs.vys) {
                // red = 0xff green goes from 0x7d to 0x00 blue = 0x00
                var top_20 = maxvxs.vxs;
                var bottom = (maxg.vxs + maxvxs.vxs) / 2;
                var green = 125 - 125 * (samp[i].vxs - bottom) / (top_20 - bottom);
                var tempc = Math.round(green).toString(16).length === 1 ? "0" + Math.round(green).toString(16) : Math.round(green).toString(16);
                color = "#ff" + tempc + "00";
            }
            else {
                // red = 0xff green = 0x00 blue goes from 0x00 to 0xff
                var top_21 = maxvys.vys;
                var bottom = maxvxs.vys;
                if (top_21 === bottom) {
                    color = "#ff0000";
                }
                else {
                    var blue = 255 * (samp[i].vys - bottom) / (top_21 - bottom);
                    color = "#ff00" + Math.round(blue).toString(16);
                }
            }
            colors.push(color);
        }
        // console.log(colors)
        return colors;
    }
    exports.polarColor = polarColor;
    //studio polars
    function studioPolarColor(samp, polar) {
        if (polar) {
            if (polar.aoas && polar.stallpoint) {
                var aoa = samplePolartable(samp.length, polar.stallpoint, polar.aoas);
                var colorsb_1 = [];
                for (var i = 0; i < samp.length - 1; i++) {
                    colorsb_1[i] = { mode: aoamodelcolor(0, (aoa[i] + aoa[i + 1]) / 2), data: [{ vxs: samp[i].vxs, vys: samp[i].vys }, { vxs: samp[i + 1].vxs, vys: samp[i + 1].vys }] };
                }
                // console.log(samp,aoa,colorsb)
                return colorsb_1;
            }
        }
        var colors = [];
        var color = "#000000";
        var maxg = samp.reduce(function (a, b) { return a.vxs / a.vys > b.vxs / b.vys ? a : b; });
        var maxvxs = samp.reduce(function (a, b) { return a.vxs > b.vxs ? a : b; });
        var maxvys = samp.reduce(function (a, b) { return a.vys > b.vys ? a : b; });
        var minsink = samp.reduce(function (a, b) { return a.vys < b.vys ? a : b; });
        var stallpoint = samp[0];
        var mgp = 0;
        for (var i = 0; i < samp.length; i++) {
            // color normal flying range
            if (samp[i].vys < maxvxs.vys) { //slower vertical than maxvxs
                if (samp[i].vxs < (stallpoint.vxs + minsink.vxs) / 2) {
                    // red goes from 0x6b to 0x00 green = 0x00 blue = 0xff
                    var top_22 = (stallpoint.vxs + minsink.vxs) / 2;
                    var bottom = stallpoint.vxs;
                    var begin = "#6b00ff";
                    var end = "#0000ff";
                    var alpha = (samp[i].vxs - bottom) / (top_22 - bottom);
                    color = interpolateColor(begin, end, alpha);
                }
                else if (samp[i].vxs < minsink.vxs) {
                    // red = 0x00 green goes from 0x00 to 0xff blue = 0xff
                    var bottom = (stallpoint.vxs + minsink.vxs) / 2;
                    var top_23 = minsink.vxs;
                    var begin = "#0000ff";
                    var end = "#00ffff";
                    var alpha = (samp[i].vxs - bottom) / (top_23 - bottom);
                    color = interpolateColor(begin, end, alpha);
                }
                else if (samp[i].vxs < (maxg.vxs + minsink.vxs) / 2) {
                    // red = 0x00 green = 0xff blue goes from 0xff to 0x00
                    var top_24 = (maxg.vxs + minsink.vxs) / 2;
                    var bottom = minsink.vxs;
                    var begin = "#00ffff";
                    var end = "#00ff00";
                    var alpha = (samp[i].vxs - bottom) / (top_24 - bottom);
                    color = interpolateColor(begin, end, alpha);
                }
                else if (samp[i].vxs < maxg.vxs) {
                    // red goes from 0x00 to 0xff green = 0xff blue = 0x00
                    var bottom = (maxg.vxs + minsink.vxs) / 2;
                    var top_25 = maxg.vxs;
                    var begin = "#00ff00";
                    var end = "#ffff00";
                    var alpha = (samp[i].vxs - bottom) / (top_25 - bottom);
                    color = interpolateColor(begin, end, alpha);
                }
                else if (samp[i].vxs < (maxg.vxs + maxvxs.vxs) / 2) {
                    if (mgp == 0) {
                        mgp = i;
                    }
                    // red = 0xff green goes from 0xff to 0x7d blue = 0x00
                    var top_26 = (maxg.vxs + maxvxs.vxs) / 2;
                    var bottom = maxg.vxs;
                    var begin = "#ffff00";
                    var end = "#ff7d00";
                    var alpha = (samp[i].vxs - bottom) / (top_26 - bottom);
                    color = interpolateColor(begin, end, alpha);
                }
                else if (samp[i].vxs < maxvxs.vxs) {
                    // red = 0xff green goes from 0x7d to 0x00 blue = 0x00
                    var top_27 = maxvxs.vxs;
                    var bottom = (maxg.vxs + maxvxs.vxs) / 2;
                    var begin = "#ff7d00";
                    var end = "#ff0000";
                    var alpha = (samp[i].vxs - bottom) / (top_27 - bottom);
                    color = interpolateColor(begin, end, alpha);
                }
            }
            else { // faster than maxvxs
                // red = 0xff green = 0x00 blue goes from 0x00 to 0xff
                var top_28 = maxvys.vxs;
                var bottom = maxvxs.vxs;
                if (top_28 == bottom) {
                    color = "#ff0000";
                }
                else {
                    var begin = "#ff0000";
                    var end = "#ff00ff";
                    var alpha = (samp[i].vxs - bottom) / (top_28 - bottom);
                    color = interpolateColor(begin, end, alpha);
                }
            }
            colors.push(color);
        }
        //console.log(samp,color)
        var colorsb = [];
        for (var i = 0; i < colors.length - 1; i++) {
            colorsb[i] = { mode: colors[i], data: [{ vxs: samp[i].vxs, vys: samp[i].vys }, { vxs: samp[i + 1].vxs, vys: samp[i + 1].vys }] };
        }
        if (mgp > 1) {
            colorsb[mgp].mode = "#000000";
        }
        //console.log(colorsb)
        return colorsb;
    }
    exports.studioPolarColor = studioPolarColor;
    function SimulatorPolarColor(samp) {
        var colors = [];
        var color = "#000000";
        //console.log(samp)
        var maxg = samp.reduce(function (a, b) { return a.vxs / a.vys > b.vxs / b.vys ? a : b; });
        //console.log(maxg)
        var maxvxs = samp.reduce(function (a, b) { return a.vxs > b.vxs ? a : b; });
        var maxvys = samp.reduce(function (a, b) { return a.vys > b.vys ? a : b; });
        var minsink = samp.reduce(function (a, b) { return a.vys < b.vys ? a : b; });
        var stallpoint = samp[0];
        for (var i = 0; i < samp.length; i++) {
            // color normal flying range
            if (samp[i].vys < maxvxs.vys) { //slower vertical than maxvxs
                if (samp[i].vxs < (stallpoint.vxs + minsink.vxs) / 2) {
                    // red goes from 0x6b to 0x00 green = 0x00 blue = 0xff
                    var top_29 = (stallpoint.vxs + minsink.vxs) / 2;
                    var bottom = stallpoint.vxs;
                    var begin = "#6b00ff";
                    var end = "#0000ff";
                    var alpha = (samp[i].vxs - bottom) / (top_29 - bottom);
                    color = interpolateColor(begin, end, alpha);
                }
                else if (samp[i].vxs < minsink.vxs) {
                    // red = 0x00 green goes from 0x00 to 0xff blue = 0xff
                    var bottom = (stallpoint.vxs + minsink.vxs) / 2;
                    var top_30 = minsink.vxs;
                    var begin = "#0000ff";
                    var end = "#00ffff";
                    var alpha = (samp[i].vxs - bottom) / (top_30 - bottom);
                    color = interpolateColor(begin, end, alpha);
                }
                else if (samp[i].vxs < (maxg.vxs + minsink.vxs) / 2) {
                    // red = 0x00 green = 0xff blue goes from 0xff to 0x00
                    var top_31 = (maxg.vxs + minsink.vxs) / 2;
                    var bottom = minsink.vxs;
                    var begin = "#00ffff";
                    var end = "#00ff00";
                    var alpha = (samp[i].vxs - bottom) / (top_31 - bottom);
                    color = interpolateColor(begin, end, alpha);
                }
                else if (samp[i].vxs < maxg.vxs) {
                    // red goes from 0x00 to 0xff green = 0xff blue = 0x00
                    var bottom = (maxg.vxs + minsink.vxs) / 2;
                    var top_32 = maxg.vxs;
                    var begin = "#00ff00";
                    var end = "#ffff00";
                    var alpha = (samp[i].vxs - bottom) / (top_32 - bottom);
                    color = interpolateColor(begin, end, alpha);
                }
                else if (samp[i].vxs < (maxg.vxs + maxvxs.vxs) / 2) {
                    // red = 0xff green goes from 0xff to 0x7d blue = 0x00
                    var top_33 = (maxg.vxs + maxvxs.vxs) / 2;
                    var bottom = maxg.vxs;
                    var begin = "#ffff00";
                    var end = "#ff7d00";
                    var alpha = (samp[i].vxs - bottom) / (top_33 - bottom);
                    color = interpolateColor(begin, end, alpha);
                }
                else if (samp[i].vxs < maxvxs.vxs) {
                    // red = 0xff green goes from 0x7d to 0x00 blue = 0x00
                    var top_34 = maxvxs.vxs;
                    var bottom = (maxg.vxs + maxvxs.vxs) / 2;
                    var begin = "#ff7d00";
                    var end = "#ff0000";
                    var alpha = (samp[i].vxs - bottom) / (top_34 - bottom);
                    color = interpolateColor(begin, end, alpha);
                }
            }
            else { // faster than maxvxs
                // red = 0xff green = 0x00 blue goes from 0x00 to 0xff
                var top_35 = maxvys.vxs;
                var bottom = maxvxs.vxs;
                if (top_35 == bottom) {
                    color = "#ff0000";
                }
                else {
                    var begin = "#ff0000";
                    var end = "#ff00ff";
                    var alpha = (samp[i].vxs - bottom) / (top_35 - bottom);
                    color = interpolateColor(begin, end, alpha);
                }
            }
            if (samp[i].vxs == maxg.vxs) {
                color = "#000000";
            }
            colors.push(color);
        }
        //console.log(samp,color)
        var colorsb = [];
        for (var i = 0; i < colors.length - 1; i++) {
            colorsb.push({ mode: colors[i], data: [{ vxs: samp[i].vxs, vys: samp[i].vys }, { vxs: samp[i + 1].vxs, vys: samp[i + 1].vys }] });
        }
        //if(mgp>1){
        //  colorsb[mgp].mode="#000000"
        //}
        //console.log(colorsb)
        return colorsb;
    }
    exports.SimulatorPolarColor = SimulatorPolarColor;
    function speedpagePolarColor(data, polar, rho) {
        var colors = [];
        var color = "#000000";
        var samp = data; //: SustainedSpeeds[] = []
        if (polar.table && polar.table.length == data.length) {
            samp = polar.table.map(function (c) { return coefftoss(c.cl, c.cd, polar.s, polar.m, rho); });
        }
        else {
            samp = samplePolar(data.length, polar, rho);
        }
        var maxg = getmaxg(polar, rho);
        var maxvxs = samp.reduce(function (a, b) { return a.vxs > b.vxs ? a : b; });
        var maxvys = samp.reduce(function (a, b) { return a.vys > b.vys ? a : b; });
        var minsink = samp.reduce(function (a, b) { return a.vys < b.vys ? a : b; });
        var stallpoint = samp[0];
        for (var i = 0; i < data.length; i++) {
            if (samp[i].vxs < (stallpoint.vxs + minsink.vxs) / 2 && samp[i].vys < maxvxs.vys) {
                // red goes from 0x6b to 0x00 green = 0x00 blue = 0xff
                var top_36 = (stallpoint.vxs + minsink.vxs) / 2;
                var bottom = stallpoint.vxs;
                var red = 107 - 107 * (samp[i].vxs - bottom) / (top_36 - bottom);
                var tempc = Math.round(red).toString(16).length === 1 ? "0" + Math.round(red).toString(16) : Math.round(red).toString(16);
                color = "#" + tempc + "00ff";
            }
            else if (samp[i].vxs < minsink.vxs && samp[i].vys < maxvxs.vys) {
                // red = 0x00 green goes from 0x00 to 0xff blue = 0xff
                var bottom = (stallpoint.vxs + minsink.vxs) / 2;
                var top_37 = minsink.vxs;
                var green = 255 * (samp[i].vxs - bottom) / (top_37 - bottom);
                var tempc = Math.round(green).toString(16).length === 1 ? "0" + Math.round(green).toString(16) : Math.round(green).toString(16);
                color = "#00" + tempc + "ff";
            }
            else if (samp[i].vxs < (maxg.vxs + minsink.vxs) / 2 && samp[i].vys < maxvxs.vys) {
                // red = 0x00 green = 0xff blue goes from 0xff to 0x00
                var top_38 = (maxg.vxs + minsink.vxs) / 2;
                var bottom = stallpoint.vxs;
                var blue = 255 - 255 * (samp[i].vxs - bottom) / (top_38 - bottom);
                var tempc = Math.round(blue).toString(16).length === 1 ? "0" + Math.round(blue).toString(16) : Math.round(blue).toString(16);
                color = "#00ff" + tempc;
            }
            else if (samp[i].vxs < maxg.vxs && samp[i].vys < maxvxs.vys) {
                // red goes from 0x00 to 0xff green = 0xff blue = 0x00
                var bottom = (maxg.vxs + minsink.vxs) / 2;
                var top_39 = maxg.vxs;
                var red = 255 * (samp[i].vxs - bottom) / (top_39 - bottom);
                var tempc = Math.round(red).toString(16).length === 1 ? "0" + Math.round(red).toString(16) : Math.round(red).toString(16);
                color = "#" + tempc + "ff00";
            }
            else if (samp[i].vxs < (maxg.vxs + maxvxs.vxs) / 2 && samp[i].vys < maxvxs.vys) {
                // red = 0xff green goes from 0xff to 0x7d blue = 0x00
                var top_40 = (maxg.vxs + maxvxs.vxs) / 2;
                var bottom = maxg.vxs;
                var green = 255 - 125 * (samp[i].vxs - bottom) / (top_40 - bottom);
                var tempc = Math.round(green).toString(16).length === 1 ? "0" + Math.round(green).toString(16) : Math.round(green).toString(16);
                color = "#ff" + tempc + "00";
            }
            else if (samp[i].vxs < maxvxs.vxs && samp[i].vys < maxvxs.vys) {
                // red = 0xff green goes from 0x7d to 0x00 blue = 0x00
                var top_41 = maxvxs.vxs;
                var bottom = (maxg.vxs + maxvxs.vxs) / 2;
                var green = 125 - 125 * (samp[i].vxs - bottom) / (top_41 - bottom);
                var tempc = Math.round(green).toString(16).length === 1 ? "0" + Math.round(green).toString(16) : Math.round(green).toString(16);
                color = "#ff" + tempc + "00";
            }
            else {
                // red = 0xff green = 0x00 blue goes from 0x00 to 0xff
                var top_42 = maxvys.vxs;
                var bottom = maxvxs.vxs;
                if (top_42 === bottom) {
                    color = "#ff0000";
                }
                else {
                    var blue = 255 * (samp[i].vxs - bottom) / (top_42 - bottom);
                    var tempc = Math.round(blue).toString(16).length === 1 ? "0" + Math.round(blue).toString(16) : Math.round(blue).toString(16);
                    // console.log(Math.round(blue).toString(16))
                    color = "#ff00" + tempc; // Math.round(blue).toString(16)
                }
            }
            // console.log(color)
            colors.push(color);
        }
        var colorsb = [];
        for (var i = 0; i < colors.length - 1; i++) {
            colorsb.push({ mode: colors[i], data: [{ vxs: samp[i].vxs, vys: samp[i].vys }, { vxs: samp[i + 1].vxs, vys: samp[i + 1].vys }] });
        }
        // console.log(colorsb)
        return colorsb;
    }
    exports.speedpagePolarColor = speedpagePolarColor;
    function rollEngineColor(n, polar) {
        var colors = polarColor(n, polar);
        var ncolors = [];
        for (var i = 0; i < Math.floor(n / 2); i++) {
            ncolors.push(colors[n - 1 - i * 2]);
        }
        if (Math.floor(n / 2) !== n / 2) { // n is odd domiddle}
            ncolors.push(colors[0]);
        }
        for (var i = 0; i < Math.floor(n / 2); i++) {
            ncolors.push(colors[i * 2]);
        }
        return ncolors;
    }
    exports.rollEngineColor = rollEngineColor;
    /*
    export function dopredictionengine(track: Track, polar: WSEQPolar, cppolar: WSEQPolar, numpoints: number, predictionlength: number, rollengine: boolean): Orientation[][] {
      const result: Orientation[][] = []
      let deploytime: any
      if (track.stats.deploy) { deploytime = track.stats.deploy.millis }
      const start = track.startTime()
      const stop = track.stopTime()
    
      // const pcfigsinit = sapmlepolar(numpoints, polar, 1.225)
      // const pccfigsinit = sapmlepolar(numpoints, cppolar, 1.225)
      // do prediction engine
      // roll needs to be negative
    
      let h = 0
      for (const point of track.data) {
        result[h] = []
        const pcfigs = samplePolar(numpoints, polar, point.rho)// const cfigs = cfigsinit.map((s:SustainedSpeeds)=>{const speeds : SustainedSpeeds = {vxs: adjustSpeed(s.vxs,track.data[0].alt,point.alt),vys:adjustSpeed(s.vxs,track.data[0].alt,point.alt)}; return speeds})
        const pccfigs = samplePolar(numpoints, cppolar, point.rho)
        // const pccfigs2 = pccfigsinit.map((s:SustainedSpeeds)=>{const speeds : SustainedSpeeds = {vxs: adjustSpeed(s.vxs,0,point.alt),vys:adjustSpeed(s.vys,0,point.alt)}; return speeds})
        // console.log(pcfigs,pccfigs,pccfigs2)
    
    
        for (let i = 0; i < numpoints; i++) {
          let current: WSPoint = {
            millis: point.millis,
            x: 0, // m
            y: 0, // m
            north: 0, // m
            east: 0, // m
            vx: Math.sqrt(point.smooth.vE * point.smooth.vE + point.smooth.vN * point.smooth.vN), // m/s
            vy: point.smooth.vD, // m/s
            vxs: point.millis < deploytime ? pcfigs[i].vxs : pccfigs[i].vxs, // m/s
            vys: point.millis < deploytime ? pcfigs[i].vys : pccfigs[i].vys, // m/s
            heading: Math.atan2(point.smooth.vE, point.smooth.vN), // rad n=0 e=90 w=-90 s = 180
            roll: -point.roll // rad
          }
          //console.log(current,i)
          for (let j = 0; j < predictionlength; j++) {
            result[h][i * predictionlength + j] = { millis: current.millis, x: -current.east, y: -current.y, z: current.north }
            // let nextt = .2
            // only do predictions if ws or canopy
            if (current.millis >= start && current.millis <= stop) {
              for (let k = h; k < track.data.length; k++) {
                if (track.data[k].millis === point.millis) {
                  if (k + j < track.data.length) {
                    if (rollengine) {
                      current.vxs = track.data[k + j].sustained_x
                      current.vys = track.data[k + j].sustained_y
                      current.roll = -(track.data[k + j].roll + (90 - (i * 180 / (numpoints - 1))) * Math.PI / 180)// roll+_90deg
                      if (current.vxs < 5) current.vxs = 5// protect from crazyness
                      if (current.vys < 5) current.vys = 5// protect from crazyness
                    }
                    else { current.roll = -track.data[k + j].roll }// speed engine foreward roll
                  } else {// past bounds
                    current.roll = 0
                  }
                  // nextt= Math.floor(k<track.data.length-1?(track.data[k+1].millis-track.data[k].millis)/100:2)/10//handle missing samples
                }
              }
              current = generate3d(.1, current)[1]// nextt,current)[10*nextt]//
              // console.log(current)
            }
          }
        }
        h = h + 1
      }
      // console.log(result)
      return result
    }
    */
    // write fake flysight file
    function simdata2flysight(simdata) {
        var h = "time,lat,lon,hMSL,velN,velE,velD,hAcc,vAcc,sAcc,heading,cAcc,gpsFix,numSV\n	,(deg),(deg),(m),(m/s),(m/s),(m/s),(m),(m),(m/s),(deg),(deg),,\n";
        var r = "";
        for (var i = 0; i < Math.min(simdata.length, 20000); i = i + 2) { // changed to 20000 points or 2000sec
            // const d0 = simdata[i].date//.setMilliseconds(simdata[i].millis)
            var d0 = new Date(simdata[i].millis);
            var d = d0.getUTCFullYear() + "-" + td(d0.getUTCMonth()) + "-" + td(d0.getUTCDay()) + "T" + td(d0.getUTCHours()) + ":" + td(d0.getUTCMinutes()) + ":" + td(d0.getUTCSeconds()) + "." + trd(d0.getTime() - Math.round(d0.getTime() / 1000) * 1000) + "Z";
            var hacc = Math.round((Math.random() + 0.5) * 1000) / 1000;
            var vacc = Math.round((Math.random() + 0.5) * 1000) / 1000;
            var sacc = Math.round((0.1 * Math.random() + 0.1) * 1000) / 1000;
            var heading = Math.round(Math.atan2(simdata[i].smooth.vN, simdata[i].smooth.vE) * 1000) / 1000;
            var cacc = Math.round((0.1 + Math.random()) * 1000) / 1000;
            var gpsfix = 3;
            var numsv = 15;
            //console.log("dates: utc" ,d )
            var l = d + "," + simdata[i].lat.toPrecision(11) + "," + simdata[i].lng.toPrecision(11) + "," + simdata[i].alt.toPrecision(8) + "," + simdata[i].smooth.vN.toPrecision(8) + "," + simdata[i].smooth.vE.toPrecision(8) + "," + simdata[i].smooth.vD.toPrecision(8) + "," + hacc + "," + vacc + "," + sacc + "," + heading + "," + cacc + "," + gpsfix + "," + numsv + "\n";
            r = r + l;
        }
        return h + r;
    }
    exports.simdata2flysight = simdata2flysight;
    // write simulator file for database
    // change to current date/time
    function simdata2csv(simdata) {
        var h = "time,lat,lon,hMSL,velN,velE,velD\n";
        var r = "";
        var rightnow = new Date();
        var lastmillis = new Date(simdata[simdata.length - 1].millis);
        var delta = rightnow.getTime() - lastmillis.getTime();
        for (var i = 0; i < Math.min(simdata.length, 20000); i = i + 2) { // changed to 20000 points or 2000sec
            // const d0 = simdata[i].date//.setMilliseconds(simdata[i].millis)
            var d0 = new Date(simdata[i].millis + delta);
            var d = d0.getUTCFullYear() + "-" + td(d0.getUTCMonth() + 1) + "-" + d0.getDate() + "T" + td(d0.getUTCHours()) + ":" + td(d0.getUTCMinutes()) + ":" + td(d0.getUTCSeconds()) + "." + trd(d0.getTime() - Math.round(d0.getTime() / 1000) * 1000) + "Z";
            //console.log("dates: utc" ,d )
            var l = d + "," + simdata[i].lat.toPrecision(11) + "," + simdata[i].lng.toPrecision(11) + "," + simdata[i].alt.toPrecision(8) + "," + simdata[i].smooth.vN.toPrecision(8) + "," + simdata[i].smooth.vE.toPrecision(8) + "," + simdata[i].smooth.vD.toPrecision(8) + "\n";
            r = r + l;
        }
        return h + r;
    }
    exports.simdata2csv = simdata2csv;
    function td(n) {
        if (n < 10) {
            return "0" + n;
        }
        else {
            return "" + n;
        }
    }
    exports.td = td;
    function trd(n) {
        if (n < 0) {
            n = 1000 + n;
        }
        if (n < 100) {
            if (n < 10) {
                return "00" + n;
            }
            return "0" + n;
        }
        else {
            return "" + n;
        }
    }
    exports.trd = trd;
    function interpolateColor(color1, color2, factor) {
        var result = "#";
        for (var i = 1; i <= 6; i += 2) {
            var color1Part = parseInt(color1.substr(i, 2), 16);
            var color2Part = parseInt(color2.substr(i, 2), 16);
            var resultPart = Math.round(color1Part + (color2Part - color1Part) * factor).toString(16);
            if (resultPart.length < 2) {
                resultPart = "0" + resultPart;
            }
            result += resultPart;
        }
        return result;
    }
    function lerpColor(color1, color2, t) {
        var c1 = hexToRgb(color1);
        var c2 = hexToRgb(color2);
        if (!(c1 && c2))
            return "#ffffff";
        var r = Math.round(c1.r + t * (c2.r - c1.r));
        var g = Math.round(c1.g + t * (c2.g - c1.g));
        var b = Math.round(c1.b + t * (c2.b - c1.b));
        return rgbToHex(r, g, b);
    }
    function hexToRgb(hex) {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        } : null;
    }
    function rgbToHex(r, g, b) {
        return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
    }
    function cubicBezier(s, t) {
        var x = Math.pow(1 - t, 3) * s[0].cl +
            3 * Math.pow(1 - t, 2) * t * s[1].cl +
            3 * (1 - t) * Math.pow(t, 2) * s[2].cl +
            Math.pow(t, 3) * s[3].cl;
        var y = Math.pow(1 - t, 3) * s[0].cd +
            3 * Math.pow(1 - t, 2) * t * s[1].cd +
            3 * (1 - t) * Math.pow(t, 2) * s[2].cd +
            Math.pow(t, 3) * s[3].cd;
        return { cl: x, cd: y };
    }
    exports.cubicBezier = cubicBezier;
});
//# sourceMappingURL=/assets/javascripts/util/wse.js.map;
